import React, { ChangeEvent } from 'react';
import { Box, Button, Container, Input } from '@mui/material';
import { DialogHeader } from '@linetweet/linetweet-ui';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Alert } from '@mui/lab';
import { AsyncButton } from '../commons';

type IProps = {
  onUploadClick: () => void;
  onDownloadClick: (() => void) | null
  setFile: (file: File | null) => void;
  canFileBeSent: boolean;
  fileLoading: boolean;
  status:{
    message: string;
    type: 'success' | 'error' ;
  } | null;
};

function StatusMessage({ status }: { status: IProps['status'] }) {
  return (
    <>
      <Alert color={status?.type}>
        {status?.message || null}
      </Alert>
    </>
  );
}

export function UploadCSVForm({
  onUploadClick,
  onDownloadClick,
  setFile,
  fileLoading,
  canFileBeSent,
  status,
}: IProps) {
  const intl = useIntl();
  const navigate = useNavigate();

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      setFile(event.target.files[0]);
    } else {
      setFile(null);
    }
  };

  return (
    <>
      <DialogHeader text={intl.formatMessage({ id: 'menu.uploadShifts' })} onClose={() => navigate('/')} />
      <Container maxWidth="lg">
        <Box maxWidth="lg" marginTop={6} display="flex" alignItems="center" justifyContent="center" gap={2}>
          <Input
            onChange={handleFileChange}
            type="file"
            inputProps={{
              accept: '.csv,.xls,.xlsx',
              multiple: false,
            }}
          />
          <AsyncButton
            onClick={onUploadClick}
            variant="contained"
            color="primary"
            loading={fileLoading}
            disabled={!canFileBeSent}
          >
            {intl.formatMessage({ id: 'uploadShifts.upload' })}
          </AsyncButton>
          <Button
            component="a"
            href="files/shifts-test.csv"
            download="shifts-test.csv"
            variant="outlined"
          >
            {intl.formatMessage({ id: 'uploadShifts.downloadTemplate' })}
          </Button>
          { onDownloadClick ? (
            <Button
              onClick={onDownloadClick}
              variant="outlined"
            >
              {intl.formatMessage({ id: 'uploadShifts.downloadLatestUpload' })}
            </Button>
          ) : null }
        </Box>
        <Box
          maxWidth="lg"
          marginTop={2}
          textAlign="center"
        >
          <Box
            maxWidth="sm"
            textAlign="center"
            margin="0 auto"
          >
            {status && <StatusMessage status={status} /> }
          </Box>
        </Box>
      </Container>
    </>
  );
}
